import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-class-buttons")
class ClassButtons extends HTMLElement {
  #classes = [];
  #classSelected;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <div class="${style.filter}">
        <button class="${style.filter__class}" selected="${!this.#classSelected}">Todos</button>  
        ${this.#classes
          .map(
            (e) => ` 
          <button class="${style.filter__class}" data-class="${e.id}" selected="${this.#classSelected === e.id}">${e.name}</button>  
        `,
          )
          .join("")}
      </div>
      `;
  }

  @willPaint
  async [trait.fetch]() {
    const { data: classes } = await supabase
      .from("class")
      .select("*, level_of_education!inner(*, grade!inner(*))")
      .eq("level_of_education.grade.school_id", this.dataset.school)
      .eq("level_of_education_id", "171ed5cf-f6c9-4128-adcc-b8498ad364ca")
      .order("name", { ascending: true });

    this.#classes = classes;
    console.log(this.#classes);

    return this;
  }

  @on.click(`button.${style.filter__class}`)
  @repaint
  [trait.classes](event) {
    this.#classSelected = event.target.dataset.class;
    const result = this.#classSelected;

    window.dispatchEvent(
      new CustomEvent("clicked", {
        detail: { result },
      }),
    );

    return this;
  }
}

export default ClassButtons;
